// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as CircularPlayButton from "../../../../common/components/play-button/components/CircularPlayButton.bs.js";
import * as PartnerScoreAssetConfig from "../assets/PartnerScoreAssetConfig.bs.js";

function VideoThumbnailCmp(Props) {
  var setShowVideo = Props.setShowVideo;
  var variant = Props.variant;
  var getThumbNail = function (v) {
    if (v !== undefined) {
      if (v) {
        return "url(" + PartnerScoreAssetConfig.v2youtubeThumbnail + ")";
      } else {
        return "url(" + PartnerScoreAssetConfig.v1youtubeThumbnail + ")";
      }
    } else {
      return "";
    }
  };
  return React.createElement("div", {
              className: "video",
              style: {
                backgroundImage: getThumbNail(variant)
              },
              onClick: (function (param) {
                  return Curry._1(setShowVideo, (function (param) {
                                return true;
                              }));
                })
            }, React.createElement(CircularPlayButton.make, {}));
}

var make = VideoThumbnailCmp;

export {
  make ,
  
}
/* react Not a pure module */
